import {
  IEmployerResponse
  } from 'src/app/core/services/peopleapi/peoplefunctionapi.services';


  export interface IMaintenanceState {
    Error: string;
    EmployerSearchResult: IEmployerResponse[];

}

export class MaintenanceState implements IMaintenanceState {
  Error: string;
  EmployerSearchResult: IEmployerResponse[];
}
